import { renderAuthoredNarrativeBundle } from './authoredNarrativeRender';
import { shouldPublishAuthoredMethodology } from './authoredNarrativeLoader';
import type { CrimeSafetyBundle } from '../../services/crimeSafetyService';

const CHART_ID = 'public_safety';

export function buildPublicSafetyTokens(
  locationName: string,
  bundle: CrimeSafetyBundle
): Record<string, string> {
  const latestYear = bundle.latestYear != null ? String(bundle.latestYear) : '—';
  const crimeMetricValue =
    bundle.latestLocalRate != null ? bundle.latestLocalRate.toFixed(1) : '—';
  const trendSentence =
    bundle.years.length >= 2 &&
    bundle.localRatePer100k[0] != null &&
    bundle.localRatePer100k[bundle.localRatePer100k.length - 1] != null
      ? ''
      : '';
  return {
    locationName,
    latestYear,
    crimeMetricValue,
    unit: 'violent crimes per 100,000 residents',
    crimeMetricLabel: 'reported violent crime rate',
    trendSentence,
    coverageSentence: bundle.fetchWarnings?.length ? ` ${bundle.fetchWarnings.join(' ')}` : '',
  };
}

export function buildPublicSafetyAuthoredBundle(locationName: string, bundle: CrimeSafetyBundle | null) {
  if (!bundle?.hasData) {
    return renderAuthoredNarrativeBundle(CHART_ID, 'default', { locationName });
  }
  const tokens = buildPublicSafetyTokens(locationName, bundle);
  const authored = renderAuthoredNarrativeBundle(CHART_ID, 'default', tokens);
  if (!shouldPublishAuthoredMethodology(authored.authoringStatus)) {
    authored.methodology = undefined;
  }
  return authored;
}
